import React from "react";
import { useFieldWrapper } from "../hooks";
import { CheckboxComponent, CheckboxComponentProps } from "./CheckboxComponent";
import FormFieldBoolean from "./FormFieldBoolean";

export const BooleanComponentWrapper = (props: CheckboxComponentProps) => {
	const WrappedComponent = useFieldWrapper(CheckboxComponent, FormFieldBoolean);
	return <WrappedComponent {...props} />;
};
